import { memo } from 'react';

import { type DragLibraryItem } from '~/components/Shared/Drag/dragTypes';

export type LibraryDragPreviewProps = {
  library: DragLibraryItem;
};

export const LibraryDragPreview = memo(({ library }: LibraryDragPreviewProps) => {
  return (
    <div className="flex w-60 items-center gap-3 rounded-8 bg-grey-3 px-2 py-2 shadow-drag-preview">
      <div
        className="flex size-6 shrink-0 items-center justify-center rounded-4 bg-grey-4 text-14 ring-1 ring-grey-4"
        style={{ backgroundColor: library.library.color?.backgroundHex }}
      >
        <span>{library.library.icon ?? '📚'}</span>
      </div>
      <div className="truncate text-14 text-grey-11">{library.library.title}</div>
    </div>
  );
});

LibraryDragPreview.displayName = 'LibraryDragPreview';
